/**
 * 报表中心管理
 */
 import axios from '../request';
 export default{
    /**
     * 模具使用报表
     */
    // 查询模具使用报表信息
    searchDieList: params =>
        axios.post('/engineering/device/mouldList', params),


     /**
     *  安全考核报表
     */

     // 查询安全考核报表信息
     searchSafetyCheckReport: (params) =>
        axios({
            method: 'post',
            url: '/secure/exam/examReportList',
            headers: {
                pageNum: params.pageNum,
                pageSize: params.pageSize
            },
            data: {
                examName: params.examName
            }
        }),
 }